// extracted by mini-css-extract-plugin
export default {"mainCard":"VideoCarousal_mainCard__y0vlx","imgCard":"VideoCarousal_imgCard__x509O","depression":"VideoCarousal_depression__6r7jh"};